import {get} from '@/lib/fetcher';

export default {
    namespaced: true,
    state: () => ({
        contestEntities: {
            pairs: {},
            players: {},
            teamPlayers: {},
            teams: {}
        }
    }),
    mutations: {
        changeContestEntities(state, newEntities) {
            state.contestEntities = newEntities;
        }
    },
    actions: {
        loadPlayerList({commit}) {
            get('/api/player')
                .then(resp => {
                    commit('changeContestEntities', resp);
                });
        }
    },
    getters: {
        pairsList: state => state.contestEntities.pairs,
        playersList: state => state.contestEntities.players,
        teamPlayers: state => state.contestEntities.teamPlayers,
        teamsList: state => state.contestEntities.teams,
        playerCurrentSessionMap: (state, getters) => {
            return getters.teamCurrentSessionMap.filter(el => el.position > -1);
        },
        teamCurrentSessionMap: (state, getters) => {
            const playerContestHistoryMap = getters.playerContestHistoryMap;

            const maxPhase = Math.max(...playerContestHistoryMap.map(el => el.phase));
            const phaseFiltered = playerContestHistoryMap.filter(el => el.phase === maxPhase);

            const maxSession = Math.max(...phaseFiltered.map(el => el.session));

            return phaseFiltered.filter(el => el.session === maxSession);
        },
        playerContestHistoryMap: (state, getters, rootState, rootGetters) => {
            const ret = [];

            const sectors = rootGetters['tournament/sector'];
            const playerCode= rootGetters['webApp/playerCode'];

            const isLookingForPairId = rootGetters['tournament/contestType'] !== 0;
            const searchedId = isLookingForPairId ? rootGetters['tournament/pairId'] : rootGetters['tournament/teamId'];

            for (const currentPhase of Object.keys(sectors.Phases)) {
                for (const currentSerie of Object.keys(sectors.Phases[currentPhase].Series)) {
                    for (const currentSession of Object.keys(sectors.Phases[currentPhase].Series[currentSerie].Sessions)) {
                        for (const currentGroup of Object.keys(sectors.Phases[currentPhase].Series[currentSerie].Sessions[currentSession].Groups)) {
                            for (const currentRound of Object.keys(sectors.Phases[currentPhase].Series[currentSerie].Sessions[currentSession].Groups[currentGroup].Rounds)) {
                                const roundState = sectors.Phases[currentPhase].Series[currentSerie].Sessions[currentSession].Groups[currentGroup].Rounds[currentRound];
                                for (const currentTable of Object.keys(roundState.Tables)) {
                                    const tableState = roundState.Tables[currentTable];
                                    const isPresent = [tableState.NsEventId, tableState.EwEventId].indexOf(searchedId);
                                    const position = [tableState.N, tableState.E, tableState.S, tableState.W].indexOf(playerCode);
                                    if (isPresent > -1) {
                                        const tableNumber = parseInt(currentTable);
                                        ret.push({
                                            session: parseInt(currentSession),
                                            round: parseInt(currentRound),
                                            position: position,
                                            table: tableNumber,
                                            sector: parseInt(currentGroup),
                                            serie: parseInt(currentSerie),
                                            rankset: parseInt(sectors.Phases[currentPhase].Series[currentSerie].Sessions[currentSession].Groups[currentGroup].Rankset),
                                            phase: parseInt(currentPhase),
                                            ...tableState
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return ret;
        }
    }
};
